import React from 'react';
import { MustIncludeOneOfBasicTestIdWithIdProps } from '../common/internal/test-id.types';
import HBBaseFormField, {
    HBBaseFormFieldProps,
    splitFieldProps
} from '../HBBaseFormField/HBBaseFormField';
import HBSwitch, { HBSwitchProps } from '../HBSwitch/HBSwitch';
import { ITooltipProps } from '../HBTooltip/HBTooltip';

export interface HBSwitchFieldProps
    extends Omit<
            Omit<HBSwitchProps, 'disabled' | 'disabledTooltipText'>,
            'size' | 'label'
        >,
        HBBaseFormFieldProps {
    /** HTML `id` for the field; used as the `<label htmlFor>` target. Required. */
    id: string;
    /** Tooltip text explaining why the switch is disabled; required in HBSwitch when disabled is true, but optional here due to type intersection limitations. */
    disabledTooltipText?: string;
    /** CSS class applied to the root element. */
    className?: string;
    /** Additional props forwarded to the HBTooltip shown when the switch is disabled (placement, offset, etc.). */
    disabledTooltipProps?: Partial<Omit<ITooltipProps, 'target'>>;
}

const SIZE_CORRECTION_MAP: Record<
    'xs' | 'sm' | 'md' | 'lg',
    HBSwitchProps['size']
> = {
    xs: 'sm',
    sm: 'sm',
    md: 'md',
    lg: 'md'
};

const HBSwitchField = ({
    size = 'sm',
    placement = 'right',
    ...props
}: HBSwitchFieldProps & MustIncludeOneOfBasicTestIdWithIdProps) => {
    const {
        fieldProps,
        inputProps: { testIdName, ...inputProps }
    } = splitFieldProps(props);

    return (
        <HBBaseFormField {...fieldProps} size={size} placement={placement}>
            <HBSwitch
                label={
                    typeof props.label === 'string' ? props.label : undefined
                }
                {...inputProps}
                size={SIZE_CORRECTION_MAP[size]}
                testIdName={testIdName}
            />
        </HBBaseFormField>
    );
};

export default HBSwitchField;
